<template>
  <OverlayCard width="xl" @cancel="$emit('cancel')">
    <template #title>
      <div v-if="title" class="filter-card__title-alt">
        {{ title }}
      </div>

      <div v-else class="filter-card__title">
        <div>
          <FilterIcon16 />
        </div>

        <div>
          {{ $t('filter.title', { entityType: $t(`entity.${entityType}`, 2) }) }}
        </div>
      </div>
    </template>

    <template #content>
      <FilterConfigurator v-model="filter" :filter-options="filterOptions" :entity-type="entityType" />
    </template>

    <template #footer>
      <div class="filter-card__footer">
        <slot name="saveButton" :filter="filter" />

        <div class="filter-card__results" data-test-id="filter-form-results">
          <FilterManager :items="items" :filter="filter" :filter-options="filterOptions">
            <template #default="filterProps">
              <div>
                <div>{{ $t('filter.results', filterProps.items.length) }}</div>
              </div>
            </template>
          </FilterManager>
        </div>
      </div>
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import FilterManager from './GlobalFilter/FilterManager.vue';
import FilterConfigurator from './GlobalFilter/FilterConfigurator.vue';
import FilterIcon16 from '@components/Icons/FilterIcon16.vue';

import { FilterList } from '@/filter/types';

export default defineComponent({
  name: 'FilterCard',
  emits: { cancel: null, confirm: null },

  components: {
    FilterManager,
    FilterConfigurator,
    FilterIcon16,
  },

  props: {
    initialFilter: {
      type: Object as PropType<FilterList>,
      required: true,
    },

    filterOptions: {
      type: Object,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    entityType: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      filter: this.initialFilter,
    };
  },

  methods: {
    /**
     * @public
     */
    confirm() {
      this.$emit('confirm', this.filter);
    },
  },
});
</script>

<style lang="scss">
.filter-card__title {
  display: grid;
  align-items: center;
  grid-gap: 8px;
  grid-template-columns: 20px 1fr;
  padding-left: 4px;
}

.filter-card__title-alt {
  text-transform: capitalize;
}

.filter-card__footer {
  flex: 1 1 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-card__results {
  text-align: right;
  font-weight: 500;
  margin-left: auto;
}
</style>
